import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { intlReducer } from 'react-intl-redux';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import reducers from 'reducers';
import config from 'config';

import sagas from 'redux/sagas';
import moduleReducers from 'redux/reducers';

import { sagaCatch } from './sagaCatch';

const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState) {
  const store = createStore(
    combineReducers({
      ...reducers,
      ...moduleReducers,
      intl: intlReducer,
    }),
    initialState,
    compose(
      applyMiddleware(
        thunkMiddleware.withExtraArgument(config), // lets us dispatch() functions
        sagaMiddleware // saga middleware
      )
    )
  );

  const rootTask = sagaMiddleware.run(sagas);
  rootTask.done.catch(sagaCatch);

  return store;
}
